import {
  GetCompetitionSeasons as GetCompetitionSeasonsAction,
  GetCompetitionSeasonsPayload,
  GetCompetitionSeasonsResponse,
} from "../../providers/supabase-provider/actions/GetCompetitionSeasons";

export { GetCompetitionSeasonsPayload, GetCompetitionSeasonsResponse };

export const GetCompetitionSeasons = async (
  payload: GetCompetitionSeasonsPayload
): Promise<GetCompetitionSeasonsResponse> => {
  return await GetCompetitionSeasonsAction(payload);
};
